"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = void 0;
function lazy(init) {
    let cache;
    let loaded = false;
    return () => {
        if (!loaded) {
            cache = init();
            loaded = true;
        }
        return cache;
    };
}
exports.lazy = lazy;
//# sourceMappingURL=lazy.js.map